import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './RoadsideHero.module.scss';

const Hero = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const title = data?.title || '';

  const backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 43.66%, rgba(0, 0, 0, 0.3) 100%), url(${imageUrl})`,
  };

  return (
    <div className={styles.wrapper} style={backgroundStyle}>
      <div data-aos="fade-up" data-aos-offset="100" dangerouslySetInnerHTML={{ __html: title }} />
    </div>
  );
};

export default Hero;
